// Feature flags for The Club app
// Set to false to hide a feature from nav/UI, true to show it
// Code is preserved — just hidden from view

const FEATURES = {
  FITNESS: false,
  TOUR_UPDATES: false,
  GPS_PLAY: false,
  SHOT_TRACKING: false,
  STROKES_GAINED: false,
  MANUAL_SCORES: true,
  DISCOVER: true,
  SOCIAL_FEED: true,
  MESSAGING: true,
};

export default FEATURES;
